module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/color-slack-5b93c5c7ad56c7424e5ce18b8d16472d.svg";